import * as Sentry from '@sentry/react'

import { getAnonymousUserId } from '$extensionSrc/metrics/idGetSet'
import { sentrySanitizeProperties } from '$extensionSrc/utils/logging'

export async function initSentry() {
  Sentry.init({
    dsn: window.SENTRY_DSN,
    environment: window.SENTRY_ENVIRONMENT,
    beforeSend(event) {
      return sentrySanitizeProperties(event)
    },
  })

  // Timezone is a very nifty way to detect country
  // https://stackoverflow.com/questions/48278024/how-to-detect-browser-country-in-client-site
  // This is what we use as a proxy for location instead of IP addresses
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone

  const id = await getAnonymousUserId()
  Sentry.setUser({ id, timezone })

  Sentry.setTag('tenant.name', window.TENANT_ID)
  Sentry.setTag('tenant.name', window.TENANT_NAME)
}
